import React, { useState, useEffect } from "react";
import "react-date-range/dist/styles.css"; // main styles
import "react-date-range/dist/theme/default.css"; // theme styles
import { useTheme } from "@mui/material";
import { BiLoaderAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import BuyNodeMessage from "../pages/Node/components/BuyNodeMessage";
import NoNodesMessage from "../pages/Node/components/NoNodesMessage";
import TableHead from "../pages/Node/components/TableHead";
import cn from "classnames";

const ClaimXBRTable = ({ claimData, hasNodes }) => {
  const [nodesData, setNodesData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
		setNodesData(claimData);
    if (claimData && claimData.length > 0) {
      setIsLoading(false);
    }
  }, [claimData]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedNodes = nodesData.sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  const theme = useTheme();
  const shortenAddress = (address) => {
    if (!address) return "";
    return `${address.substring(0, 6)}...${address.substring(
      address.length - 4
    )}`;
  };

  const sortByNodeId = () => {
    requestSort("nodeId");
  };

  const sortByAmount = () => {
    requestSort("rewardPricePerBlock");
  };

  const sortByClaimedBlock = () => {
    requestSort("claimedBlock");
  };

  const sortByTXHash = () => {
    requestSort("txHash");
  };

  return (
    <div
      className={cn("overflow-y-hidden overflow-y-scroll hide-scrollbar ")}
      style={{ height: "calc(100% - 80px)" }}
    >
      {isLoading && (
        <div className="absolute inset-0 flex justify-center items-center bg-opacity-50 bg-transparent">
          <BiLoaderAlt
            className="animate-spin"
            size={50}
            color={theme.palette.mode === "light" ? "#000" : "#fff"}
          />
        </div>
      )}
      <table
        className={`w-full max-h-[948px] hide-scrollbar table-auto overflow-y-hidden ${
          isLoading ? "opacity-50" : ""
        }`}
      >
        <thead
          className={
            "sticky top-0 border-b border-lightGrayBlue dark:border-darkSlateBlue bg-white   dark:bg-darkCardBg z-10"
          }
        >
          <tr className="grid grid-cols-12 md:grid-cols-11 w-full">
            <TableHead
              thName={"Node ID"}
              sortData={sortByNodeId}
              classes={"col-span-3 md:col-span-2"}
            />
            <TableHead
              thName={"Amount"}
              sortData={sortByAmount}
              classes={"col-span-3"}
            />
            <TableHead
              thName={"Block No."}
              sortData={sortByClaimedBlock}
              classes={"col-span-3"}
            />
            <TableHead
              thName={"TX hash"}
              sortData={sortByTXHash}
              classes={"col-span-3"}
            />
          </tr>
        </thead>
        <tbody>
          {sortedNodes.length > 0 ? (
            sortedNodes.map((row, index) => (
              <tr
                key={index}
                className={
                  "grid grid-cols-12 md:grid-cols-11 w-full border-b border-lightGrayBlue dark:border-darkSlateBlue"
                }
              >
                <td className="col-span-3 md:col-span-2 py-5">
                  <span className="px-3 inline-block	text-xs leading-6 text bg-center rounded-lg bg-lightBlue dark:bg-[#302E47] text-semiBlack dark:text-semiWhite h-6">
                    {row.nodeId}
                  </span>
                </td>
                <td className="col-span-3 py-5 text-xs  md:text-sm leading-6 text-black dark:text-white">
                  {row.rewardPricePerBlock}
                </td>
                <td className="col-span-3 py-5 text-xs md:text-sm leading-6 text-black dark:text-white">
                  {row.claimedBlock}
                </td>

                <td className="col-span-3 py-5 text-xs  md:text-sm leading-6 text-black dark:text-white">
                  <Link
                    to={`https://polygonscan.com/tx/${row.txHash}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {shortenAddress(row.txHash)}
                  </Link>
                </td>
              </tr>
            ))
          ) : hasNodes ? (
            <NoNodesMessage message={"XBR claims history"} />
          ) : (
            <BuyNodeMessage messageText={"claims"} />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ClaimXBRTable;
